import React from 'react';
import { useReviewsDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { useReviews, extend } from '@thd-nucleus/data-sources';
import { dataModel } from './ratings-and-reviews-data-model';

export const ReviewsLoader = ({ itemId, children }) => {
  const variables = {
    filters: {
      isVerifiedPurchase: false,
      prosCons: null,
      starRatings: null
    },
    searchTerm: null,
    sortBy: 'photoreview',
    startIndex: 1
  };
  const { data, loading, error } = useReviewsDeprecated({
    itemId,
    variables,
    skip: !itemId
  });
  return children({
    data,
    loading,
    error
  });
};

ReviewsLoader.dataModel = {
  reviews: dataModel?.reviews
};
